var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChannelTimeAverage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1441_27732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5327 6.4582C12.5577 5.4832 11.2827 4.99154 9.99935 4.99154V9.99154L6.46602 13.5249C8.41602 15.4749 11.5827 15.4749 13.541 13.5249C15.491 11.5749 15.491 8.4082 13.5327 6.4582ZM9.99935 1.6582C5.39935 1.6582 1.66602 5.39154 1.66602 9.99154C1.66602 14.5915 5.39935 18.3249 9.99935 18.3249C14.5993 18.3249 18.3327 14.5915 18.3327 9.99154C18.3327 5.39154 14.5993 1.6582 9.99935 1.6582V1.6582ZM9.99935 16.6582C6.31602 16.6582 3.33268 13.6749 3.33268 9.99154C3.33268 6.3082 6.31602 3.32487 9.99935 3.32487C13.6827 3.32487 16.666 6.3082 16.666 9.99154C16.666 13.6749 13.6827 16.6582 9.99935 16.6582Z",
    fill: "#F35451"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1441_27732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelTimeAverage);
export default __webpack_public_path__ + "static/media/channel-time-average.45f9c51852cca8ae654dd840e2c33863.svg";
export { ForwardRef as ReactComponent };